export const GradeIndex = 1
export const DesignationIndex = 5
export const LocationIndex = 6
export const BusinessUnitIndex = 8